import { Map } from "immutable";
import { CASE_CREATE_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants/index";
import { CaseEntryRecord, AssociateRecord } from "records/index";

const INITIAL_STATE = new Map({
    status: STATE_STATUS.IDLE,
    case: new CaseEntryRecord(),
    applicant_details: new AssociateRecord(),
    errors: null,
    bulkAdhocCases: new Map({
        status: null,
        data: null,
        error: null
    })
});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
    case CASE_CREATE_ACTIONS.CREATE_CASE:
        return state.set("status", STATE_STATUS.ENGAGED)
            .set("case", payload.caseEntry.set("status", STATE_STATUS.CREATING));
    case CASE_CREATE_ACTIONS.CREATED_CASE:
        return state.set("status", STATE_STATUS.IDLE)
            .set("case", payload.caseEntry);
    case CASE_CREATE_ACTIONS.FAILED_CREATE_CASE:
        return state.set("status", STATE_STATUS.IDLE)
            .set("case", payload.caseEntry)
            .set("applicant_details", new AssociateRecord(payload.contact_detail))
            .set("errors", error);
    case CASE_CREATE_ACTIONS.RESET_CASE_CREATE:
        return INITIAL_STATE;
    case CASE_CREATE_ACTIONS.REMOVE_CASE_ENTRY:
        return state.set("status", STATE_STATUS.IDLE)
            .set("case", null)
            .set("applicant_details", null);
    case CASE_CREATE_ACTIONS.OPEN_CASE:
    case CASE_CREATE_ACTIONS.UPDATE_OPEN_CASE:
        return state.mergeIn(["cases"], payload.cases);
    case CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATE:
        return state
            .setIn(["bulkAdhocCases", "status"], STATE_STATUS.CREATING)
            .setIn(["bulkAdhocCases", "data"], payload.caseData);
    case CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATED:
        return state
            .setIn(["bulkAdhocCases", "status"], STATE_STATUS.CREATED)
            .setIn(["bulkAdhocCases", "data"], payload.caseData);
    case CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATE_FAILED:
        return state
            .setIn(["bulkAdhocCases", "status"], STATE_STATUS.CREATED)
            .setIn(["bulkAdhocCases", "data"], payload.caseData)
            .setIn(["bulkAdhocCases", "error"], payload.error);
    case CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATE:
        return state
            .setIn(["bulkPayProCases", "status"], STATE_STATUS.CREATING)
            .setIn(["bulkPayProCases", "data"], payload.caseData);
    case CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATED:
        return state
            .setIn(["bulkPayProCases", "status"], STATE_STATUS.CREATED)
            .setIn(["bulkPayProCases", "data"], payload.caseData);
    case CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATE_FAILED:
        return state
            .setIn(["bulkPayProCases", "status"], STATE_STATUS.CREATE_FAILED)
            .setIn(["bulkPayProCases", "data"], payload.caseData)
            .setIn(["bulkPayProCases", "error"], payload.error);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
